
<script>
import { mapActions } from 'vuex';
export default {
    name: 'article-detail',
    created() {

        const {params, query} = this.$route;
        this.routerQuery = this.$route;
        this.textDetail({id: +params.id}, query.event);

    },
    data() {
        return {
            article: {
            },
            routerQuery: {}
        };
    },
    methods: {
        async textDetail(params, evnet) {
            this.$loading(true);
            try {
                const {data} = await this[evnet](params);
                this.article = data;
            } catch (e) {
                throw e;
            } finally {
                this.$loading(false);
            }
        },
        ...mapActions('zft', ['getTextDetail', 'getPolicyDetail', 'getPurTextDetail'])
    },
    filters: {
        filterTime(time){
            return time ? time.split(' ')[0] : '';
        }
    }
};
</script>
<template>
<article class="article-detail">
    <h1>{{article.title}}</h1>
    <div class="article-opearte">
        <div class="article-tags">
            <span>{{article.province}}{{article.city || ''}}</span>
            <span v-if="article.infoType">{{article.infoType}}</span>
            <span class="time">{{(article.createTime || article.releaseTime) | filterTime}}</span>
        </div>
    </div>
    <main>
        <div class="article-main" v-html="article.text"></div>
    </main>
    <a :href="article.dealsUrl" target="_blank" v-if="article.dealsUrl">查看原文</a>
</article>
</template>
<style scoped lang="stylus">
.article-detail
    margin-bottom 10px
    padding 20px 60px
    h1
        margin 0
    .article-opearte
        display flex
        justify-content space-between
        align-items center
        .article-tags
            margin 10px 0 20px
            >span
                font-size 12px
                padding 4px 8px
                border-radius 3px
                color #fff
                margin-bottom 10px
                background #008ebc
                margin-right 15px
        .icon-collect
            font-size 25px
            color gray
            cursor pointer
        .icon-collect-active
            color $activeColor
    main
        line-height 2
        margin-bottom 10px
        text-indent 30px
        margin-top 10px
</style>
